import {combineReducers} from '@ngrx/store';
import {organizationDocumentFeatureKey, organizationDocumentReducer, OrganizationDocumentState} from '@documents/organization-document/_store/organization-document.reducer';
import {dahDocumentFeatureKey, dahDocumentReducer, DahDocumentState} from "@documents/dah-documents/_store/dah-documents.reducer";

export const documentFeatureKey = 'documents';

export interface DocumentsState {
    [organizationDocumentFeatureKey]: OrganizationDocumentState,
    [dahDocumentFeatureKey]: DahDocumentState
}

export const documentsReducers = combineReducers({
    [organizationDocumentFeatureKey]: organizationDocumentReducer,
    [dahDocumentFeatureKey]: dahDocumentReducer
});




